import { UPDATE_COUPON_REDUCER } from "store/actionTypes";
import { ActionType, CouponReducerModal } from "utils/modals";

export const CouponReducer = (
  state: CouponReducerModal = new CouponReducerModal(),
  action: ActionType
) => {
  switch (action.type) {
    case UPDATE_COUPON_REDUCER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default CouponReducer;
